import { type UploadFile } from "antd"
import { type Dayjs } from "dayjs"

/**
 * Action types
 */
export enum OneFleetEntregaFormsTypes {
  "SET_DATA" = "@onefleetentrega/SET_DATA",
  "CLEAR_DATA" = "@onefleetentrega/CLEAR_DATA",

  "PREVIEW_PDF_CLEAR" = "@onefleetentrega/PREVIEW_PDF_CLEAR",
  "PREVIEW_PDF_REQUEST" = "@onefleetentrega/PREVIEW_PDF_REQUEST",
  "PREVIEW_PDF_SUCCESS" = "@onefleetentrega/PREVIEW_PDF_SUCCESS",
  "PREVIEW_PDF_FAILURE" = "@onefleetentrega/PREVIEW_PDF_FAILURE",

  "SEARCH_PLATE_CLEAR" = "@onefleetentrega/SEARCH_PLATE_CLEAR",
  "SEARCH_PLATE_REQUEST" = "@onefleetentrega/SEARCH_PLATE_REQUEST",
  "SEARCH_PLATE_SUCCESS" = "@onefleetentrega/SEARCH_PLATE_SUCCESS",
  "SEARCH_PLATE_FAILURE" = "@onefleetentrega/SEARCH_PLATE_FAILURE",

  "FINAL_PDF" = "@onefleetentrega/FINAL_PDF"
}

/**
 * Data types
 */
export interface OneFleetEntregaForm {
  formId?: string

  email?: string
  name?: string
  cpf?: string
  clientPhone?: string
  clientPhoneCountry?: { code: string, country: string }
  company?: string
  licensePlate?: string
  pickupDate?: Dayjs
  carKm?: number
  model?: string
  dealer?: string
  consultantName?: string
  consultantEmail?: string

  hasCarProblem?: boolean
  carProblemDescription?: string
  carProblemImages?: UploadFile[]
  cnhImages?: UploadFile[]
  licensePlateImages?: UploadFile[]
  terms?: boolean

  surveyGrade?: number
  surveyDescription?: string

  clientPicture?: UploadFile
  clientSignatureDots?: SignaturePad.Point[][]
  clientSignatureImage?: string

  plateInfo?: OneFleetEntregaPlateInfo
  plateInfoError?: boolean
  plateInfoMessage?: string
}

export interface OneFleetEntregaPlateInfo {
  data?: {
    company?: string
    model?: string
    carKm?: number
    dealer?: string
  }
  error?: boolean
  message?: string
  loading?: boolean
}

export interface OneFleetEntregaFormPDFPreview {
  pdf?: Buffer
  error?: boolean
  message?: string
  loading?: boolean
}

/**
 * State type
 */
export interface OneFleetEntregaFormsState {
  readonly data: OneFleetEntregaForm
  readonly PDFPreview?: OneFleetEntregaFormPDFPreview
  readonly plateInfo?: OneFleetEntregaPlateInfo
}
